import { Dropdown as EtDropdown } from "@ever-tutor/et-ui";
import type { ComponentProps, ReactNode } from "react";

type DropdownProps = Omit<
  ComponentProps<typeof EtDropdown>,
  "title" | "leadingContent" | "trailingContent" | "unstyled"
> & {
  title: string;
  leadingIcon?: ReactNode;
  count?: number;
};

/** Live owns the filter appearance; the shared control owns interaction. */
export default function Dropdown({
  title,
  variant = "primary",
  leadingIcon,
  count,
  buttonClassName = "",
  menuClassName = "",
  ...props
}: DropdownProps) {
  const compact = variant === "analytics";
  return (
    <EtDropdown
      {...props}
      title={title}
      variant={variant}
      unstyled={compact}
      className={compact ? "et-filter-dropdown" : props.className}
      buttonClassName={
        compact ? `et-filter-trigger ${buttonClassName}` : buttonClassName
      }
      menuClassName={
        compact ? `et-filter-menu ${menuClassName}` : menuClassName
      }
      menuLabel={compact ? `${title} options` : props.menuLabel}
      leadingContent={leadingIcon}
      trailingContent={
        count !== undefined ? (
          <span className="et-filter-count">{count}</span>
        ) : undefined
      }
      dismissOnOutsidePress={compact || props.dismissOnOutsidePress}
      dismissOnEscape={compact || props.dismissOnEscape}
    />
  );
}
